module.exports = __webpack_public_path__ + "media/default.4640852f.wav";